export default __webpack_public_path__ + "static/media/tfp-bottle@3x.7a95e462.png";